@if (parentBranding$ | async; as branding) {
  <a [href]="'mailto:' + address + '@' + branding.domain" [ngClass]="class">{{ address }}&#64;{{ branding.domain }}</a>
} @else {
  <a [href]="'mailto:' + address + '@zef.fi'" [ngClass]="class">{{ address }}&#64;zef.fi</a>
}
